import styled from "styled-components";
import { ShareLinkContainerBg } from "@assets";
import { Button as AntButton } from 'antd';

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`;

export const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const HistoryBox = styled.div`
  border-radius: 12px;
  background: #f4e8f9;
  padding: 16px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: baseline;
  align-items: flex-start;
  row-gap: 6px;
`;

export const View = styled.p`
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Amount = styled.p`
  color: #49028E;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Date = styled.p`
  color: #9B92BB;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh - 48px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const EmptyBox = styled.div`
	width: 100%;
	height: calc(100vh - 70px - 160px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const NoResultText = styled.div`
	padding-top: 16px;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #5D5189;
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 12px 16px;
  column-gap: 22px;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;

  background-image: url(${ShareLinkContainerBg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  margin-bottom: 24px;
`

export const Link = styled.p`
  color: #FFF;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 200% */
`

export const CopyButton = styled(AntButton)`
  background-color: #E5E0F5 !important;
  border-radius: 8px;
  border: none;
  padding: 8px;

  color: #000 !important;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  :hover{
    color: #000 !important;
    background-color: #E5E0F5 !important;
  }
`

export const EmptyHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`